import { BUDGET_RANGES, CASE_STATUSES, TARGET_AUDIENCES, } from "@kansai-ai-hub/types";
import { z } from "zod";
// enum 値は @kansai-ai-hub/types を単一の正とする（prisma との重複定義のズレ防止）
export const caseStatusEnum = z.enum(CASE_STATUSES);
export const budgetRangeEnum = z.enum(BUDGET_RANGES);
export const targetAudienceEnum = z.enum(TARGET_AUDIENCES);
/**
 * E-2 案件登録で利用
 */
export const useCaseSchema = z.object({
    title: z
        .string()
        .min(1, "案件名を入力してください")
        .max(120, "案件名は120文字以内で入力してください"),
    summary: z
        .string()
        .min(1, "案件概要を入力してください")
        .max(1000, "1000文字以内で入力してください"),
    challenge: z
        .string()
        .min(1, "課題内容を入力してください")
        .max(2000, "2000文字以内で入力してください"),
    expectedDev: z.string().max(2000).optional(),
    industry: z.string().max(100).optional(),
    technologies: z
        .array(z.string().max(40, "タグは40文字以内で入力してください"))
        .max(20, "対象技術は20件まで指定できます")
        .default([]),
    budgetRange: budgetRangeEnum.optional(),
    targetAudience: targetAudienceEnum.optional(),
    notes: z.string().max(1000).optional(),
});
export const updateUseCaseSchema = useCaseSchema;
/**
 * 案件ステータス変更
 */
export const updateCaseStatusSchema = z.object({
    status: caseStatusEnum,
});
/**
 * 一覧フィルタ
 */
export const useCaseListQuerySchema = z.object({
    q: z.string().max(200).optional(),
    industry: z.string().max(100).optional(),
    technology: z.string().max(40).optional(),
    budget: budgetRangeEnum.optional(),
    status: caseStatusEnum.optional(),
    /** カンマ区切りで複数指定（単数フィールドと排他、複数版優先） */
    statuses: z.string().max(200).optional(),
    industries: z.string().max(1000).optional(),
    technologies: z.string().max(1000).optional(),
    budgets: z.string().max(200).optional(),
    /** 企業名（投稿企業）での絞り込み。カンマ区切りで複数指定。 */
    organizationNames: z.string().max(2000).optional(),
    // page は深いオフセットによるコストアンプ（OFFSET スキャン）を避けるため上限を設ける。
    page: z.coerce.number().int().min(1).max(10_000).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(12),
});
